import React from 'react'
import { formatNumber } from 'util/strings'
import styles from './styles.less'

export default function Count({ count }) {
  if (!Number.isInteger(count)) return null

  return (
    <div className={styles.count} size="large">
      {count === 0 ? '\u{1F389}' : formatNumber(count)}
    </div>
  )
}
